module.exports = __webpack_public_path__ + "static/media/ProductAction.fe0a5980.png";